/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Productcount1Inputs */

const en__field_productcount1 = /** @type {(inputs: _Field_Productcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product count`)
};

const de__field_productcount1 = /** @type {(inputs: _Field_Productcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Produkte`)
};

/**
* | output |
* | --- |
* | "Product count" |
*
* @param {_Field_Productcount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_productcount1 = /** @type {((inputs?: _Field_Productcount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Productcount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_productcount1(inputs)
	return de__field_productcount1(inputs)
});
export { _field_productcount1 as "_field_productCount" }